import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import pdf from 'src/repositories/pdf';

const apiKey = '/top-screen/pdf-url';

const usePDF = () => {
  const { data, ...rest } = useQuery<
    AxiosResponse<Response.FilesPDF>,
    AxiosError<any>
  >([apiKey], pdf.getFilesPDF, {
    retry: 0,
    onError(err) {
      console.log(err.response);
    },
  });
  return {
    files: data?.data?.item,
    ...rest,
  };
};

export default usePDF;
